"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogService = void 0;
var LogService = /** @class */ (function () {
    function LogService() {
        this.debug = false;
    }
    LogService.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.debug) {
            console.log.apply(this, args);
        }
    };
    LogService.prototype.setDebug = function (debug) {
        this.debug = debug;
    };
    return LogService;
}());
exports.LogService = LogService;
